import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state: {
        //windonsrc: 'http://192.168.1.117:8990/api/sys/file/static/',
        windonsrc:'http://47.93.189.238:9041/api/sys/file/static/',
        windowheight: '',
        dialogImageUrl: "",
        dialogVisibleImg: false,
    },
    mutations: {
        //es6语法，等同edit:funcion(){...}
        setheight(state, height) {
            console.log(height)
            state.windowheight = height
        }
    }
})
const actions = {
    lookImg(url) {
        for (var i = 0; i < url.length; i++) {
            url[i] = store.state.windonsrc + url[i]
        }
        store.state.dialogImageUrl = url;
        store.state.dialogVisibleImg = true;
    },
    goInfo(id, url, titleName, type, href) {
        console.log(111222)
        console.log(type)
        const _router = window.Vue.$router
        _router.push({
            name: "checkMsg",
            query: {
                id: id,
                api: JSON.stringify({
                    check: url,
                }),
                titleName: titleName,
                type: type,
                href: href
            },
        });
    },
    goInfo2(id, url, titleName, type, href) {
        console.log(111222)
        console.log(type)
        const _router = window.Vue.$router
        _router.push({
            name: "EducationMsg",
            query: {
                id: id,
                api: JSON.stringify({
                    check: url,
                }),
                titleName: titleName,
                type: type,
                href: href
            },
        });
    },
}

export default {
    store,
    actions
}



// WEBPACK FOOTER //
// ./src/store/index.js